Dygraph.Plugins.Trovis = function () {
    var self = this;

    this.activate = function (g) {
        var self = this;

        this.replaceMethods(g);
        this.createSelectorLine(g);
        g.setSelectorLine = function (pts) {
            if (this.selectorLine != undefined) {
                $(this.selectorLine).css('left', '' + pts[0].canvasx + 'px');
                $(this.selectorLine).show();
            }
        };

        g.hideSelectorLine = function (pts) {
            if (this.selectorLine != undefined) {
                $(this.selectorLine).hide();
            }
        };

        g.getSeriesInfo = function (name) {
            var list = this.getOption('seriesInfo');
            var r = _.where(list, { label: name });
            if (r.length > 0) return r[0];
            return undefined;
        };

        g.isInterpolatedValue = function (index, seriesIndex, debug) {
            var interpolated = this.getOption('interpolatedData');
            if (!interpolated) return false;

            var bit = 1 << seriesIndex;
            if (debug !== undefined && (interpolated[index] & bit) == bit)
                return JSON.stringify({
                    interpolated: interpolated[index],
                    index: index,
                    seriesIndex: seriesIndex,
                });

            return (interpolated[index] & bit) == bit;
        };

        g.updateOptions(
            {
                highlightCallback: function (e, x, pts) {
                    this.setSelectorLine(pts);
                },
            },
            true
        );
    };

    this.replaceMethods = function (g) {
        // Based on the original computeYAxes_
        g.computeYAxes_ = function () {
            // Preserve valueWindow settings if they exist, and if the user hasn't
            // specified a new valueRange.
            var valueWindows, axis, index, opts, v;
            if (g.axes_ !== undefined && g.user_attrs_.hasOwnProperty('valueRange') === false) {
                valueWindows = [];
                for (index = 0; index < g.axes_.length; index++) {
                    valueWindows.push(g.axes_[index].valueWindow);
                }
            }

            // BEGIN MOD
            if (g.user_attrs_.hasOwnProperty('valueWindow')) {
                valueWindows = [];
                for (index = 0; index < g.axes_.length; index++) {
                    var w = g.user_attrs_.valueWindow;

                    _.each(g.user_attrs_.axes, function (ax, key) {
                        if (DygraphOptions.AXIS_STRING_MAPPINGS_[key] == index) {
                            if (ax.valueWindow) w = ax.valueWindow;
                        }
                    });
                    valueWindows.push(w);
                }
            }
            // END MOD

            // this.axes_ doesn't match this.attributes_.axes_.options. It's used for
            // data computation as well as options storage.
            // Go through once and add all the axes.
            g.axes_ = [];

            for (axis = 0; axis < g.attributes_.numAxes(); axis++) {
                // Add a new axis, making a copy of its per-axis options.
                opts = { g: g };
                Dygraph.update(opts, g.attributes_.axisOptions(axis));
                g.axes_[axis] = opts;
            }

            // Copy global valueRange option over to the first axis.
            // NOTE(konigsberg): Are these two statements necessary?
            // I tried removing it. The automated tests pass, and manually
            // messing with tests/zoom.html showed no trouble.
            v = g.attr_('valueRange');
            if (v) g.axes_[0].valueRange = v;

            if (valueWindows !== undefined) {
                // Restore valueWindow settings.

                // When going from two axes back to one, we only restore
                // one axis.
                var idxCount = Math.min(valueWindows.length, g.axes_.length);

                for (index = 0; index < idxCount; index++) {
                    g.axes_[index].valueWindow = valueWindows[index];
                }
            }

            for (axis = 0; axis < g.axes_.length; axis++) {
                if (axis === 0) {
                    opts = g.optionsViewForAxis_('y' + (axis ? '2' : ''));
                    v = opts('valueRange');
                    if (v) g.axes_[axis].valueRange = v;
                } else {
                    // To keep old behavior
                    var axes = g.user_attrs_.axes;
                    if (axes && axes.y2) {
                        v = axes.y2.valueRange;
                        if (v) g.axes_[axis].valueRange = v;
                    }
                }
            }
        };
    };

    this.createSelectorLine = function (g) {
        g.selectorLine = document.createElement('div');
        var jqc = $(g.selectorLine);
        jqc.css('width', '1px');
        jqc.css('display', 'none');
        jqc.css('height', '100%');
        jqc.css('position', 'absolute');
        jqc.css('background-color', 'rgba(255, 192, 168, 10)');
        jqc.css('pointer-events', 'none');
        $(g.graphDiv).append(jqc);
    };

    this.toString = function () {
        return 'Trovis Team Dygraph Plugin';
    };
};

var DygraphUtils = {
    addOptions: function (opt) {
        var tryCount = 100;
        var doAdd = function () {
            if (Dygraph.OPTIONS_REFERENCE) {
                if (opt.isArray) opt = [opt];
                _.each(opt, function (o) {
                    Dygraph.OPTIONS_REFERENCE[o.name] = o;
                });
            } else {
                setTimeout(function () {
                    tryCount--;
                    if (tryCount) doAdd();
                }, 10);
            }
        };

        doAdd();
    },
};

Dygraph.PLUGINS.push(Dygraph.Plugins.Trovis);
DygraphUtils.addOptions([
    {
        name: 'valueWindow',
        default: 'undefined',
        labels: ['valueWindow'],
        type: 'array',
        description: 'Zoom Y Bereich',
    },
    {
        name: 'interpolatedData',
        default: 'undefined',
        labels: ['interpolatedData'],
        type: 'array',
        description: 'Interpolated Data',
    },
    {
        name: 'timeshift',
        default: 'undefined',
        labels: ['timeshift'],
        type: 'object',
        description: 'Time shift',
    },
    {
        name: 'originalData',
        default: 'undefined',
        labels: ['originalData'],
        type: 'array',
        description: 'Original Data',
    },
    { name: 'seriesInfo', default: 'undefined', labels: ['seriesInfo'], type: 'array', description: 'seriesInfo' },
    { name: 'isLast', default: 'undefined', labels: ['isLast'], type: 'int', description: 'isLast' },
    { name: 'barWidth', default: 'undefined', labels: ['barWidth'], type: 'int', description: 'Bar width' },
]);

module.exports = DygraphUtils;
